<div class="delivery-group-detail" *ngIf="group">
  <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="back()">
      <nb-icon icon="arrow-back-outline"></nb-icon>
      {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.BACK' | translate }}
    </button>
    <div class="d-flex flex-wrap gap-2">
      <button
        type="button"
        class="btn btn-sm btn-outline-primary"
        *ngIf="reviewSummary && reviewSummary.unchangedPending > 0"
        (click)="bulkApproveUnchanged()">
        {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.BULK_UNCHANGED_ALL' | translate }}
      </button>
      <button type="button" class="btn btn-sm btn-primary" (click)="confirmApply()" [disabled]="!canApply">
        {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.APPLY_CTA' | translate:{ count: applyLineCount } }}
      </button>
    </div>
  </div>

  <div class="alert alert-danger" *ngIf="loadError">{{ loadError }}</div>

  <nb-card class="mb-3">
    <nb-card-body>
      <div class="row g-2">
        <div class="col-md-6">
          <div class="fw-semibold">{{ group.supplierDisplayName || group.supplierKey }}</div>
          <div class="small text-muted">
            {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.KUNDENUMMER' | translate }}: {{ group.kundenummer || '—' }}
          </div>
          <div class="small">
            {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.DELIVERY_DATE' | translate }}:
            {{ group.deliveryDate | date:'dd/MM/yyyy' }}
          </div>
          <div class="small text-muted mt-1">
            {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.INVOICE_COUNT' | translate:{ count: group.importCount || imports.length } }}
          </div>
        </div>
        <div class="col-md-6 text-md-end">
          <div class="fw-semibold">
            {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.TOTAL_INCL' | translate }}:
            {{ group.totals?.totalInclVat | number:'1.2-2':'da-DK' }} kr.
          </div>
          <div class="small text-muted" *ngIf="group.lineCounts?.needsAttention">
            {{ 'INVOICE_IMPORTS.LIST.NEEDS_ATTENTION' | translate:{ count: group.lineCounts?.needsAttention } }}
          </div>
          <div class="status-chips mt-2 justify-content-md-end">
            <span
              class="badge me-1"
              *ngFor="let st of groupStatusKeys()"
              [ngClass]="st | invoiceImportStatusClass">
              {{ statusLabelKey(st) | translate }} ({{ importStatusBadgeCount(st) }})
            </span>
          </div>
        </div>
      </div>

      <div class="member-invoices mt-3">
        <span class="small text-muted me-2">{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.MEMBER_INVOICES' | translate }}</span>
        <button
          type="button"
          class="btn btn-sm btn-outline-secondary me-1 mb-1"
          *ngFor="let imp of imports"
          (click)="openMemberImport(imp._id)">
          {{ imp.invoiceNumber || imp._id }}
          <span class="text-muted" *ngIf="imp.invoiceSite">({{ imp.invoiceSite }})</span>
        </button>
      </div>
    </nb-card-body>
  </nb-card>

  <div class="review-summary-bar mb-3" *ngIf="reviewSummary">
    <span class="small text-muted me-1">{{ 'INVOICE_IMPORTS.DETAIL.REVIEW_SUMMARY_PREFIX' | translate }}</span>
    <button type="button" class="btn btn-sm summary-chip" [class.active]="lineFilter === 'large'" (click)="setLineFilter('large')">
      {{ 'INVOICE_IMPORTS.DETAIL.REVIEW_SUMMARY_LARGE' | translate:{ count: reviewSummary.large } }}
    </button>
    <span class="mx-1">·</span>
    <button type="button" class="btn btn-sm summary-chip" [class.active]="lineFilter === 'toCheck'" (click)="setLineFilter('toCheck')">
      {{ 'INVOICE_IMPORTS.DETAIL.REVIEW_SUMMARY_TOCHECK' | translate:{ count: reviewSummary.toCheck } }}
    </button>
    <span class="mx-1">·</span>
    <button type="button" class="btn btn-sm summary-chip" [class.active]="lineFilter === 'unchanged'" (click)="setLineFilter('unchanged')">
      {{ 'INVOICE_IMPORTS.DETAIL.REVIEW_SUMMARY_UNCHANGED' | translate:{ count: reviewSummary.unchangedPending } }}
    </button>
    <span class="mx-1">·</span>
    <button
      type="button"
      class="btn btn-sm summary-chip"
      [class.active]="lineFilter === 'autoApproved' || autoApprovedPanelOpen"
      (click)="toggleAutoApprovedPanel()">
      {{ 'INVOICE_IMPORTS.DETAIL.REVIEW_SUMMARY_AUTO' | translate:{ count: reviewSummary.autoApproved } }}
    </button>
    <button type="button" class="btn btn-sm btn-link summary-all" [class.active]="lineFilter === 'all'" (click)="setLineFilter('all')">
      {{ 'INVOICE_IMPORTS.DETAIL.FILTER_ALL' | translate }}
    </button>
    <button
      type="button"
      class="btn btn-sm btn-link summary-all"
      [class.active]="lineFilter === 'needs_review'"
      (click)="setLineFilter('needs_review')">
      {{ 'INVOICE_IMPORTS.DETAIL.FILTER_DEFAULT' | translate }}
    </button>
  </div>

  <p class="small text-muted mb-3 unchanged-hint" *ngIf="showUnchangedPendingHint">
    {{ 'INVOICE_IMPORTS.DETAIL.UNCHANGED_PENDING_HINT' | translate:{ count: unchangedPendingCount } }}
  </p>

  <ul class="small text-muted mb-3" *ngIf="!canApply && applyBlockedReasons.length">
    <li *ngFor="let r of applyBlockedReasons">{{ blockedReasonLabel(r) }}</li>
  </ul>

  <nb-card class="mb-3 apply-result-card" *ngIf="applySummary">
    <nb-card-body>
      <div class="fw-semibold mb-2">{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.APPLY_RESULT_TITLE' | translate }}</div>
      <p class="mb-2">
        {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.APPLY_RESULT_TOTALS' | translate:{
          applied: applySummary.totals?.applied,
          stock: applySummary.totals?.stockUnitsAdded,
          cost: applySummary.totals?.costUpdated,
          price: applySummary.totals?.priceUpdated
        } }}
      </p>
      <ul class="list-unstyled small mb-0">
        <li *ngFor="let r of applySummary.results" [class.text-danger]="!r.ok" [class.text-success]="r.ok">
          <span class="fw-semibold">{{ r.invoiceNumber || r.importId }}</span>:
          <ng-container *ngIf="r.ok">
            {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.APPLY_RESULT_OK' | translate:{
              applied: r.applied,
              stock: r.stockUnitsAdded
            } }}
          </ng-container>
          <ng-container *ngIf="!r.ok">{{ applyResultErrorLabel(r) }}</ng-container>
        </li>
      </ul>
    </nb-card-body>
  </nb-card>

  <nb-card class="mb-3 auto-approved-panel" *ngIf="autoApprovedPanelOpen && autoApprovedLines.length">
    <nb-card-header class="py-2">
      {{ 'INVOICE_IMPORTS.DETAIL.AUTO_APPROVED_TITLE' | translate:{ count: autoApprovedLines.length } }}
    </nb-card-header>
    <nb-card-body class="py-2">
      <div class="auto-line-row" *ngFor="let line of autoApprovedLines; trackBy: trackByLineId">
        <div class="flex-grow-1">
          <div class="small text-muted">{{ line.invoiceNumber }} ({{ line.invoiceSite }})</div>
          <div class="fw-semibold">{{ lineProductName(line) }}</div>
          <div class="small">
            {{ formatKrPlain(line.autoApproval?.oldCost) }} → {{ formatKrPlain(line.autoApproval?.newCost) }} kr
          </div>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="undoAutoApprove(line)">
          {{ 'INVOICE_IMPORTS.DETAIL.UNDO_AUTO_APPROVE' | translate }}
        </button>
      </div>
    </nb-card-body>
  </nb-card>

  <ng-template #lineActions let-line="line">
    <ng-container *ngIf="isApprovableLine(line)">
      <div class="form-check small mb-1">
        <input
          class="form-check-input"
          type="checkbox"
          [(ngModel)]="lineDrafts[line._id].acceptCostPrice"
          (change)="onAcceptCostToggle(line)" />
        <label class="form-check-label">{{ 'INVOICE_IMPORTS.DETAIL.ACCEPT_COST' | translate }}</label>
      </div>
      <div class="cost-keep-reason mb-2" *ngIf="!lineDrafts[line._id].acceptCostPrice">
        <label class="form-label small mb-1">{{ 'INVOICE_IMPORTS.DETAIL.COST_KEEP_REASON_LABEL' | translate }}</label>
        <div class="d-flex flex-wrap gap-1 mb-1">
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            *ngFor="let pickKey of costKeepQuickPickKeys"
            (click)="applyCostKeepQuickPick(line, pickKey)">
            {{ costKeepQuickPickLabel(pickKey) }}
          </button>
        </div>
        <input
          class="form-control form-control-sm"
          [(ngModel)]="lineDrafts[line._id].costKeepReason"
          [placeholder]="'INVOICE_IMPORTS.DETAIL.COST_KEEP_REASON_PLACEHOLDER' | translate" />
        <div class="text-danger small" *ngIf="lineApproveErrors[line._id]">{{ lineApproveErrors[line._id] }}</div>
      </div>
      <button
        type="button"
        class="btn btn-sm btn-outline-primary suggested-chip mb-1"
        *ngIf="line.suggestedSalePrice != null && line.suggestedSalePriceRule"
        (click)="useSuggestedPrice(line)">
        {{ suggestedPriceChipLabel(line) }}
      </button>
      <div class="input-group input-group-sm mb-1">
        <input
          type="number"
          class="form-control"
          [(ngModel)]="lineDrafts[line._id].newSalePrice"
          (change)="patchLineField(line)" />
        <button
          type="button"
          class="btn btn-outline-secondary"
          *ngIf="showUseRecommendedPrice(line)"
          (click)="useRecommendedPrice(line)">
          {{ 'INVOICE_IMPORTS.DETAIL.USE_RECOMMENDED_PLAIN' | translate }}
        </button>
      </div>
      <div class="btn-group btn-group-sm">
        <button type="button" class="btn btn-success" (click)="approveLine(line)">{{ 'INVOICE_IMPORTS.DETAIL.APPROVE' | translate }}</button>
        <button type="button" class="btn btn-outline-danger" (click)="rejectLine(line)">
          {{ 'INVOICE_IMPORTS.DETAIL.REJECT' | translate }}
        </button>
      </div>
      <button
        type="button"
        class="btn btn-link btn-sm p-0 mt-1"
        *ngIf="line.matchStatus === 'unmatched' || line.matchStatus === 'ambiguous'"
        (click)="startProductSearch(line)">
        {{ 'INVOICE_IMPORTS.DETAIL.LINK_PRODUCT' | translate }}
      </button>
      <div *ngIf="productSearchLineId === line._id" class="product-search mt-2">
        <input class="form-control form-control-sm" [(ngModel)]="productSearchQ" (keyup)="searchProducts()" />
        <button
          type="button"
          class="btn btn-sm btn-light w-100 text-start mt-1"
          *ngFor="let p of productSearchResults"
          (click)="linkProduct(line, p._id)">
          {{ p.name }} · {{ p.barcode }}
        </button>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #lineMeta let-line="line">
    <div class="d-flex gap-2">
      <img *ngIf="lineImageUrl(line)" [src]="lineImageUrl(line)" alt="" class="line-thumb" />
      <div class="flex-grow-1">
        <div class="d-flex align-items-center gap-2 flex-wrap">
          <span class="severity-bar" [ngClass]="line.changeSeverity | invoiceImportLineSeverityClass"></span>
          <span *ngIf="severityLabel(line.changeSeverity)" [ngClass]="line.changeSeverity | invoiceImportLineSeverityBadgeClass">
            {{ severityLabel(line.changeSeverity) }}
          </span>
          <div class="fw-semibold">{{ lineProductName(line) }}</div>
        </div>
        <div class="small text-muted" *ngIf="line.ean">EAN {{ line.ean }}</div>
        <div class="info-chips" *ngIf="lineInfoReasons(line).length">
          <span class="badge info-reason-chip me-1" *ngFor="let ir of lineInfoReasons(line)">{{ infoReasonLabel(ir) }}</span>
        </div>
        <div class="attention-chips">
          <span class="badge bg-light text-dark me-1" *ngFor="let ar of visibleReasons(line.attentionReasons)">
            {{ attentionLabel(line, ar) }}
          </span>
        </div>
        <span class="badge me-1" [ngClass]="line.reviewStatus | invoiceImportLineReviewClass">{{ reviewStatusLabel(line.reviewStatus) }}</span>
        <span class="badge bg-light text-dark ms-1" *ngIf="line.matchStatus">{{ matchStatusLabel(line.matchStatus) }}</span>
      </div>
    </div>
  </ng-template>

  <div class="text-center py-4" *ngIf="showNoLinesState">
    <p class="text-muted">{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.NO_LINES' | translate }}</p>
  </div>

  <div class="text-center py-4" *ngIf="showEmptyFilterState && !showNoLinesState">
    <p class="text-muted">{{ 'INVOICE_IMPORTS.DETAIL.NO_LINES_IN_FILTER' | translate }}</p>
  </div>

  <div class="table-responsive d-none d-lg-block" *ngIf="!showNoLinesState && visibleLines.length">
    <table class="table table-sm align-middle line-review-table">
      <thead>
        <tr>
          <th>{{ 'INVOICE_IMPORTS.DETAIL.COL_PRODUCT' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.COL_QTY' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.DETAIL.COL_COST' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.DETAIL.COL_PRICE' | translate }}</th>
          <th>{{ 'INVOICE_IMPORTS.DETAIL.COL_ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let line of visibleLines; trackBy: trackByLineId; let i = index">
          <tr class="invoice-group-header" *ngIf="shouldShowInvoiceGroupHeader(line, i, visibleLines)">
            <td colspan="5" class="bg-light fw-semibold small py-2">
              {{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.INVOICE_SECTION' | translate }}:
              {{ line.invoiceNumber || '—' }}
              <span class="text-muted" *ngIf="line.invoiceSite">({{ line.invoiceSite }})</span>
            </td>
          </tr>
          <tr [ngClass]="line.changeSeverity | invoiceImportLineSeverityClass">
            <td>
              <ng-container *ngTemplateOutlet="lineMeta; context: { line: line }"></ng-container>
            </td>
            <td>
              <div>{{ quantityDisplay(line) }}</div>
              <div class="small text-muted">{{ 'INVOICE_IMPORTS.DELIVERY_GROUPS.QTY_READONLY_HINT' | translate }}</div>
            </td>
            <td>
              <div class="small fw-semibold" *ngIf="costChangeLabel(line)">{{ costChangeLabel(line) }}</div>
              <div class="small fw-semibold" *ngIf="!costChangeLabel(line) && newCostOnlyLabel(line)">{{ newCostOnlyLabel(line) }}</div>
              <div class="small">{{ marginTransitionLabel(line) }}</div>
            </td>
            <td>
              <div class="small" *ngIf="showRecommendedOnly(line)">{{ recommendedOnlyLabel(line) }}</div>
              <div class="small" *ngIf="!showRecommendedOnly(line) && retailGapLabel(line)">{{ retailGapLabel(line) }}</div>
              <div class="small" *ngIf="line.productSnapshot">
                {{ 'INVOICE_IMPORTS.DETAIL.CURRENT' | translate }}: {{ formatMoney(line.productSnapshot?.price) }}
              </div>
              <div class="small" [class.text-danger]="isMarginBelowMinimum(line)">{{ marginAtCurrentLabel(line) }}</div>
            </td>
            <td>
              <ng-container *ngTemplateOutlet="lineActions; context: { line: line }"></ng-container>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div class="d-lg-none line-cards" *ngIf="!showNoLinesState && visibleLines.length">
    <ng-container *ngFor="let line of visibleLines; trackBy: trackByLineId; let i = index">
      <div class="invoice-group-header small fw-semibold py-2 px-1" *ngIf="shouldShowInvoiceGroupHeader(line, i, visibleLines)">
        {{ line.invoiceNumber }} <span class="text-muted" *ngIf="line.invoiceSite">({{ line.invoiceSite }})</span>
      </div>
      <nb-card class="mb-2 line-card" [ngClass]="line.changeSeverity | invoiceImportLineSeverityClass">
        <nb-card-body class="py-2">
          <ng-container *ngTemplateOutlet="lineMeta; context: { line: line }"></ng-container>
          <div class="small text-muted my-1">{{ quantityDisplay(line) }}</div>
          <div class="small mb-1" *ngIf="costChangeLabel(line)">{{ costChangeLabel(line) }}</div>
          <div class="small mb-2" *ngIf="retailGapLabel(line)">{{ retailGapLabel(line) }}</div>
          <ng-container *ngTemplateOutlet="lineActions; context: { line: line }"></ng-container>
        </nb-card-body>
      </nb-card>
    </ng-container>
  </div>
</div>
